module.exports = __webpack_public_path__ + "img/new_charitable.a7ad801e.svg";